import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { SvgPreloadService } from '../svg-icon/svgPreload.service';

interface SourceArray {
  [key: string]: string;
}

@Component({
  selector: 'app-svg',
  templateUrl: './svg.component.html',
  styleUrls: ['./svg.component.scss']
})

export class SvgComponent implements OnInit {
  @ViewChild('svgContainer', { static: true }) svgContainer: ElementRef;

  // @Input() public src:any="";
  @Input() public classSvg: any;
  @Input() public iconType: "Pin"| "SmDelete" | "Search" | "Clear"|"SmallClaer"|"UndoSVG"|"Polygon1"|"Polygon2"|"Polygon11"|"Polygon12"|"SearchBig"|"childrenItem"|"Delete"|"Selectimage"|"ColoredPin" | "DeleteIconDesabled" |"EditIconDisabled" |"Edit" |"Search"
  |"Close" |"Tasks"|"Meeting" |"Notes"|"Reminders" |"Quotes"|"Emails" |"Phonecall" |"File" |"Pluscolor" |"Editcolor" |"Ibutton" |"MarkAsComplete" |"Group" |"CheckMark"|"CircleClose" |"Files" |"DownloadeTmplate" |"DownloadGreycolor" |"UploadeSuccess" |"UploadFaild"
 |"Setting" |"UpArrow" |"DownArrow" |"BigDownArrow" |"BigUpArrow" |"User" |"CrossCircle" |"EditTaskList" |"Comment" |"Add" |"AddTask" |"Notification" |"DownArrow1" | "AddCircleDisabled" | "AddCircleEnabled" | "BigCheck" | "stepFail" | "stepCheckbox" | "document";

  src: any = '';

  srcBasePath = "";

  iconSources: SourceArray = {
    "Pin": "./assets/SVGIcons/pin.svg",
    "ColoredPin": "./assets/SVGIcons/coloredPin.svg",
    "ArrowDown": "./assets/SVGIcons/arrow-down-icon.svg",
    "Clear":"./assets/SVGIcons/Clearicon.svg",
    "Selectimage":"./assets/SVGIcons/selectimage.svg",
    "SmallClaer":"./assets/SVGIcons/smallClaer.svg",
    "UndoSVG":"./assets/SVGIcons/undoSVG.svg",
    "SmDelete": "./assets/SVGIcons/smDelete.svg",
    "Polygon1": "./assets/SVGIcons/Polygon1.svg",
    "Polygon2": "./assets/SVGIcons/Polygon2.svg",
    "Polygon11": "./assets/SVGIcons/polygon11.svg",
    "Polygon12": "./assets/SVGIcons/Polygon12.svg",
    "SearchBig": "./assets/SVGIcons/searchBigIcon.svg",
    "Delete": "./assets/SVGIcons/deleteicon.svg",
    "childrenItem": "childrenItem.icon",
    "DeleteIconDesabled":"./assets/SVGIcons/deleteIconDesabled.svg",
    "EditIconDisabled":"./assets/SVGIcons/editIconDisabled.svg",
    "Edit":"./assets/SVGIcons/editIcon.svg",
    "EditTaskList":"./assets/SVGIcons/edit.svg",
    "Editcolor":"./assets/SVGIcons/EditcolorIcon.svg",
    "Search":"./assets/SVGIcons/searchicon.svg",
    "Close":"./assets/SVGIcons/close-icon.svg",
    "Tasks":"./assets/SVGIcons/Tasks.svg",
    "Meeting":"./assets/SVGIcons/Meeting.svg",
    "Notes":"./assets/SVGIcons/Notes.svg",
    "Reminders":"./assets/SVGIcons/Reminders.svg",
    "Quotes":"./assets/SVGIcons/Quotes.svg",
    "Emails":"./assets/SVGIcons/Emails.svg",
    "Phonecall":"./assets/SVGIcons/phone-call.svg",
    "File":"./assets/SVGIcons/File.svg",
    "Pluscolor":"./assets/SVGIcons/plus-color.svg",
    "Add":"./assets/SVGIcons/Add.svg",
    "AddTask":"./assets/SVGIcons/addTask.svg",
    "Notification":"./assets/SVGIcons/notification.svg",
    "MarkAsComplete":"./assets/SVGIcons/mark-as-complete-icon.svg",
    "Ibutton":"./assets/SVGIcons/I_button.svg",
    "Group":"./assets/SVGIcons/Group 41672.svg",
    "CheckMark":"./assets/SVGIcons/check-mark (1).svg",
    "CircleClose":"./assets/SVGIcons/circle-close.svg",
    "Files":"./assets/SVGIcons/files.svg",
    "DownloadeTmplate":"./assets/SVGIcons/downloadeTmplateicon.svg",
    "DownloadGreycolor":"./assets/SVGIcons/download_greycolor.svg",
    "UploadeSuccess":"./assets/SVGIcons/uploadesuccess.svg",
    "UploadFaild":"./assets/SVGIcons/uploadFaild.svg",
    "Setting":"./assets/SVGIcons/settingIcon.svg",
    "UpArrow":"./assets/SVGIcons/upIcon-arrow.svg",
    "DownArrow":"./assets/SVGIcons/downIcon-arrow.svg",
    "BigDownArrow":"./assets/SVGIcons/bigdown-arrow.svg",
    "User":"./assets/SVGIcons/user.svg",
    "CrossCircle":"./assets/SVGIcons/crossCircleIcon.svg",
    "Comment":"./assets/SVGIcons/comment.svg",
    "DownArrow1":"./assets/SVGIcons/downArrow1.svg",
    "DateIcon":"./assets/SVGIcons/dateIcon.svg",
    "BigUpArrow":"./assets/SVGIcons/bigup-arrow.svg",
    "AddCircleDisabled":"./assets/SVGIcons/AddCircleDisabled.svg",
    "AddCircleEnabled":"./assets/SVGIcons/AddCircleEnabled.svg",
    "BigCheck":"./assets/SVGIcons/BigCheck.svg",
    "stepFail": "./assets/SVGIcons/import/step-fail.svg",
    "stepCheckbox": "./assets/SVGIcons/import/step-checkbox.svg",
    "document": "./assets/SVGIcons/import/document.svg",


    // "Clear": "./assets/SVGIcons/clear.svg",
    // "Delete": "./assets/SVGIcons/delete.svg",
    // "Search": "./assets/SVGIcons/search.svg"
  };

  constructor(private renderer: Renderer2, private el: ElementRef,
    private http: HttpClient, private svgPreloader: SvgPreloadService) {
  }


  ngOnInit(): void {
    if (this.iconType) {
        this.src = this.iconSources[this.iconType];

        if (this.src) {
            this.http.get(this.src, { responseType: 'text' }).subscribe(svg => {
                if (svg) {
                    this.el.nativeElement.innerHTML = svg;
                }
            });
        }
    }
    // this.svgPreloader.preloadSvg(this.src)
    // .then(svg => this.el.nativeElement.innerHTML = svg)
    // .catch(error => console.error('Error preloading SVG:', error));
  }

}
